import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {RouterProvider} from 'react-router5';
import {AppContainer} from 'react-hot-loader';
import ReactGA from 'react-ga';
import {datadogLogs} from '@datadog/browser-logs';

import PaymentApp from './paymentApp';
import configureStore from '../store';
import paymentRouter from './paymentRouter';
import config from '../config';

ReactGA.initialize(config.GOOGLE_TRACKING_ID);

datadogLogs.init({
  clientToken: config.DD_CLIENT_KEY,
  service: 'payments-app',
  env: `mhd-${config.envName}`,
});

const render = () => {
  const store = configureStore(paymentRouter);
  paymentRouter.setDependency('store', store);
  paymentRouter.start(() => {
    ReactDOM.render(
      <AppContainer>
        <Provider store={store}>
          <RouterProvider router={paymentRouter}>
            <PaymentApp />
          </RouterProvider>
        </Provider>
      </AppContainer>,
      document.getElementById('paymentRoot'),
    );
  });
};

render();

if (module.hot) {
  module.hot.accept('./paymentApp', () => {
    render();
  });
}



// WEBPACK FOOTER //
// ./src/paymentApp/index.js